module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-3-c865283fb83fbfdbdf4d9246e0c6641f.jpg";